import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import Api from '@/lib/api/api';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-confirm-email.hbs';

    var ConfirmEmailView = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            password: '#password',
            load_spinner: '.loader',
            submit_btn: '.btn.btn-primary'
        },
        events: {
            'submit form': 'onSubmit'
        },
        initialize: function (options) {
            this.destroyOnClose();
            this.focusFirstInput();
        },
        onSubmit: function (e) {
            var alertsCh = Radio.channel('alerts');
            e.preventDefault();
            this.ui.load_spinner.show();
            var id = this.model.id;
            this.model.save(
                {
                    data: {
                        id: this.model.id,
                        type: this.model.type,
                    }
                },
                {
                    url: Api.urls.account({ id: id }) + '/email/' + this.getOption('token'),
                    method: 'POST',
                }
            ).then(function () {
                this.closeDialog();
                alertsCh.request(
                    'showAlert',
                    { message: 'Successfully updated ' + this.model.get('username') + '\'s email.',
                      messageType: 'success'});
            }.bind(this), function (err) {
                this.ui.load_spinner.hide();
                var error_message;
                if (err) {
                    if (err.responseJSON && err.responseJSON.errors) {
                        if (err.responseJSON.errors[0].detail) {
                            error_message = String(err.responseJSON.errors[0].title + ' ' + err.responseJSON.errors[0].detail);
                        }
                    }
                }
                if (!error_message) {
                    error_message = 'Failed to update ' + this.model.get('username');
                }
                this.showAlert('failure', 'Failed to update, ' + error_message);
                this.listenToOnce(this, 'input', function () {
                    this.hideAlert();
                }.bind(this));
            }.bind(this));
        }
    });
    export default ConfirmEmailView;

